export default __webpack_public_path__ + "static/smartphone-5e50577d06bf51177dc51be980b7de7a.png";